module.exports = __webpack_public_path__ + "static/media/medal-1.23ff8a45.png";